<template>
  <Layout>
    <PageHeader title="KMS Video" />

    <div class="watch-container">
      <div class="watch-layout">

        <!-- MAIN VIDEO -->
        <div class="watch-main">

          <div class="video-wrapper">
            <iframe
              v-if="video.youtube_video_id"
              :src="youtubeEmbedUrl"
              frameborder="0"
              allowfullscreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </div>

          <h3 class="video-title">
            {{ video.title || "-" }}
          </h3>

          <div class="video-meta">
            <span class="badge bg-soft-primary">
              {{ video.category_name || "-" }}
            </span>
          </div>

          <div class="video-description">
            <p v-if="video.description">
              {{ video.description }}
            </p>
            <p v-else class="text-muted">
              Tidak ada deskripsi.
            </p>
          </div>

        </div>

        <!-- RELATED VIDEOS -->
        <div class="watch-sidebar" v-if="relatedVideos.length">
          <h6 class="sidebar-title">Video Terkait</h6>

          <div class="related-list">
            <div
              v-for="v in relatedVideos"
              :key="v.id"
              class="related-item"
              @click="goWatch(v.id)"
            >
              <img :src="getThumbnail(v.youtube_video_id)" />
              <div class="related-info">
                <div class="related-title">
                  {{ v.title }}
                </div>
                <small class="text-muted">
                  {{ v.category_name }}
                </small>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";

export default {
  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      video: {},
      allVideos: [],
    };
  },

  computed: {
    youtubeEmbedUrl() {
      if (!this.video.youtube_video_id) return "";
      return `https://www.youtube.com/embed/${this.video.youtube_video_id}`;
    },

    relatedVideos() {
      if (!this.video.id) return [];
      return this.allVideos
        .filter(
          v =>
            v.id !== this.video.id &&
            v.category_id === this.video.category_id
        )
        .slice(0, 6);
    },
  },

  mounted() {
    this.fetchVideo();
    this.fetchAllVideos();
  },

  watch: {
    "$route.params.id"() {
      this.fetchVideo();
    },
  },

  methods: {
    authHeader() {
      return {
        Authorization: "Bearer " + localStorage.access_token,
      };
    },

    fetchVideo() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            `master/kms/video/${this.$route.params.id}`,
          { headers: this.authHeader() }
        )
        .then(res => {
          this.video = res.data.data || {};
        });
    },

    fetchAllVideos() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kms/video",
          { headers: this.authHeader() }
        )
        .then(res => {
          this.allVideos = res.data.data || [];
        });
    },

    goWatch(id) {
      this.$router.push(`/kms/video-user/watch/${id}`);
    },

    getThumbnail(videoId) {
      return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    },
  },
};
</script>

<style scoped>
.watch-container {
  max-width: 1400px;
  margin: auto;
  padding: 16px 24px 40px;
}

.watch-layout {
  display: grid;
  grid-template-columns: 2.6fr 1fr;
  gap: 24px;
}

.video-wrapper {
  position: relative;
  padding-top: 56.25%;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
}

.video-wrapper iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.video-title {
  margin-top: 16px;
  font-weight: 600;
}

.video-meta {
  margin: 8px 0 12px;
}

.video-description {
  font-size: 14px;
  line-height: 1.6;
  background: #f8f9fa;
  padding: 12px 16px;
  border-radius: 8px;
}

.watch-sidebar {
  position: sticky;
  top: 90px;
}

.sidebar-title {
  font-weight: 600;
  margin-bottom: 12px;
}

.related-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.related-item {
  display: flex;
  gap: 10px;
  cursor: pointer;
}

.related-item img {
  width: 120px;
  height: 68px;
  object-fit: cover;
  border-radius: 8px;
}

.related-title {
  font-size: 14px;
  font-weight: 500;
}
</style>
